import React, { useState, useContext, useEffect } from 'react'
import { Button, Col, Divider, Row, message, Modal, Table } from 'antd'
import { useHistory } from 'react-router'
import { Context } from '../../../../context'
import ProjectProductList from './ProjectProductList'
import PosPaymentProject from '../PosPaymentProject'
import PosSrc from '../../PosSrc'
import DBService from '../../../../utils/DBService'
import ContentModalMainProject from './ContentModalMainProject'
import inventorySrc from '../../../inventory/inventorySrc'

function ProjectIndex(props) {
  const history = useHistory()
  const [{ auth }, dispatch] = useContext(Context)
  const [productsList, setProductsList] = useState([])
  const [addProducts, setAddProducts] = useState(true)
  const [total, setTotal] = useState(0)
  const [edit, setEdit] = useState(false)
  const [saveSell, setSaveSell] = useState(false)
  const [loading, setLoading] = useState(false)
  const [sellCancelled, setSellCancelled] = useState(false)
  const [itemsWithoutStock, setItemsWithoutStock] = useState([])
  const [symbol, setSymbol] = useState('')
  const [visible, setVisible] = useState(false)
  const [getProject, setGetProject] = useState({})

  useEffect(() => {
    async function fetchData() {
      const store = await PosSrc.getStore(props.store.id)
      setSymbol(store.company.currency.symbol)
    }

    fetchData()
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    setProductsList([])
  }, [])

  const getProductsList = data => {
    let amount = 0
    data.map(p => (amount += parseFloat(p.total)))
    setTotal(amount)
    setProductsList(data)
  }

  const cancelSell = () => {
    window.location.reload(false);
  }

  const finishProject = () => {
    setSaveSell(true)
  }

  const showMainModal = async (projectShow) => {
    let getProject = null
    let SkusOptions = null
    
    try {
      getProject = await PosSrc.getProject(projectShow.id)
      SkusOptions = await inventorySrc.getSkusOptions()
      setLoading(false)
    } catch (err) {
      console.log(err)
      history.go(0)
      return false
    }
    
    if (getProject.store.company.country.name === 'Honduras') {
      getProject.project_details.forEach(element => {
        SkusOptions.data.forEach(item => {
          if (element.presentation_id === item.presentation_id) {
            element.presentation_id = item.code
          }
        });
      });
    }

    setGetProject(getProject)
    setVisible(true)
  }

  const closeProject = async (data, validate) => {
    if (validate) {
      setLoading(true)
      const sells = await DBService.getAll('sells')
      if (sells.length > 0) await saveOfflineSells(sells)
      if (data.id) {
        PosSrc.updateProject(data, data.id).then(projectShow => {
          if (projectShow.errors?.message && projectShow.errors?.message[0] === 'Error de conexion') {
            DBService.addOne(data, 'sells').then(projectShow => {
              message.success('Se ha modificado el proyecto')
              setLoading(false)
              cancelSell()
            })
          }
          if (projectShow?.errors && Object.keys(projectShow.errors)?.length > 0) {
            checkErrors(projectShow)
            setLoading(false)
            return false
          } else {
            message.success('Se ha modificado el proyecto')
            getCash(projectShow)
          }
        })
          .catch(err => {
            console.log(err)
            setLoading(false)
            message.error('Error al modificar el proyecto')
            return false
          })
      } else {
        PosSrc.saveProject(data).then(projectShow => {
          if (projectShow.errors?.message && projectShow.errors?.message[0] === 'Error de conexion') {
            DBService.addOne(data, 'sells').then(projectShow => {
              message.success('Se ha guardado el proyecto')
              setLoading(false)
              cancelSell()
            })
          }
          if (projectShow?.errors && Object.keys(projectShow.errors)?.length > 0) {
            checkErrors(projectShow)
            setLoading(false)
            return false
          } else {
            message.success('Se ha guardado el proyecto')
            getCash(projectShow)
          }
        })
          .catch(err => {
            console.log(err)
            setLoading(false)
            message.error('Error al guardar el proyecto')
            return false
          })
      }
    }

    setSaveSell(false)
  }

  const getProductsNotAvailable = () => {
    PosSrc.productsNotAvailable(props.store.id)
      .then(res => {
        res.data.data.length ? showItemsWithLowStock(res.data.data) : history.go(0)
      })
      .catch(err => {
        console.log(err)
        history.go(0)
        return false
      })
  }

  const makeContentTable = (items) => {
    const columns = [
      {
        title: 'Descripción',
        dataIndex: 'description',
        key: 'description',
      },
      {
        title: 'Disponibilidad',
        dataIndex: 'stock',
        key: 'stock',
      }
    ]

    const dataSource = items.map((item, index) => ({
      key: index,
      description: item.description,
      stock: item.stock
    }))

    return <Table dataSource={dataSource} columns={columns} />
  }

  const showErrorItemsWithoutStock = (items) => {
    setItemsWithoutStock(items)

    let message = makeContentTable(items)

    Modal.warning({
      title: 'Productos con Stock Bajo',
      content: message,
      // onOk: () => { onChangeView(true) },
      width: '60%'
    });
  }

  const makeTableItemsWithLowStock = (items) => {
    const columns = [
      {
        title: 'Descripción',
        dataIndex: 'product_description',
        key: 'product_description',
      },
      {
        title: 'Disponibilidad',
        dataIndex: 'quantity',
        key: 'quantity',
      }
    ]

    const dataSource = items.map((item, index) => ({
      key: index,
      product_description: item.product_description,
      quantity: item.quantity
    }))

    return <Table dataSource={dataSource} columns={columns} />
  }

  const showItemsWithLowStock = (items) => {
    let message = makeTableItemsWithLowStock(items)

    Modal.warning({
      title: 'Productos con Stock Bajo',
      content: message,
      // onOk: () => { history.go(0) },
      width: '60%'
    });
  }

  const checkErrors = res => {
    Object.keys(res.errors).map(key => {
      switch (key) {
        case 'phone':
          message.error(res.errors[key][0].replace('phone', 'Teléfono'))
          break
        case 'nit':
          message.error(res.errors[key][0].replace('nit', 'NIT'))
          break
        case 'description':
          message.error(res.errors[key][0].replace('description', 'Descripción'))
          break
        case 'name':
          message.error(res.errors[key][0].replace('name', 'Nombre'))
          break
        case 'email':
          message.error(res.errors[key][0].replace('email', 'Correo Electrónico '))
          break
        case 'items':
          showErrorItemsWithoutStock(res.errors.items[0])
          break
        default:
          message.error(res.errors[key])
          break
      }
      return null
    })
  }

  const getCash = projectShow => {
    PosSrc.getStoreCash(projectShow.store_id).then(response => {
      dispatch({
        type: 'TURN CASH',
        payload: response.data[0],
      })
      
      showMainModal(projectShow)
    })
  }

  const saveOfflineSells = async data => {
    let _data = {
      store_id: data[0].store_id,
      sells: data.map(d => ({
        seller_id: auth.id,
        store_turn_id: d.store_turn_id,
        payment_method_id: d.payment_method_id,
        description: d.description,
        name: d.name,
        nit: d.nit,
        address: d.address,
        phone: d.phone,
        email: d.email,
        items: d.items,
      })),
    }
    try {
      const response = await PosSrc.saveOfflineSells(_data)

      if (!response?.errors) await DBService.deleteAll('sells')
    } catch (err) {
      console.log(err)
    }
  }

  const onChangeView = status => {
    let validate = true

    productsList.map((dataSrc, i) => {
      if (!validate) return null

      if (productsList.length - 1 > i || productsList.length === 1) {
        if (
          [dataSrc.price, dataSrc.product, dataSrc.units].includes(null) ||
          [dataSrc.price, dataSrc.product, dataSrc.units].includes(undefined) ||
          [dataSrc.price, dataSrc.product, dataSrc.units].includes('')
        ) {
          message.warning(`Todos los campos son obligatorios`)
          validate = false
        } else if (!Number(dataSrc.price) || dataSrc.price.includes('-') || dataSrc.price.includes('+')) {
          message.warning(`El campo Precio unitario debe ser un número mayor o igual a 0`)
          validate = false
        } else if (!Number(dataSrc.units) || dataSrc.units.toString().includes('-') || dataSrc.units.toString().includes('+')) {
          message.warning(`El campo No. Unidades debe ser un número mayor o igual a 0`)
          validate = false
        } else if (dataSrc.total < 0) {
          message.warning('El monto total debe ser mayor o igual a 0')
          validate = false
        } else {
          validate = true
        }
      }
      return true
    })

    if (validate) {
      setAddProducts(status)
      setEdit(status)
    }
  }

  function trunc(x, decimalDigits = 2, returnText = true, longFixed = true) {
    x = Number(x);
    decimalDigits = Number(decimalDigits);

    x = x * (10 ** decimalDigits);
    x = x - x % 1;
    x = x / (10 ** decimalDigits);

    if (returnText)
      if (longFixed)
        return x.toFixed(decimalDigits);
      else
        return x.toString();
    else
      return x;
  }

  return (
    <>
      <Row gutter={16} className={'sell-row'}>
        <ContentModalMainProject
          getProject={getProject}
          getProductsNotAvailable={getProductsNotAvailable}          
          setProjectData={props.setProjectData}
          setActiveKey={props.setActiveKey}
          setVisible={setVisible}
          visible={visible}
          onChangeView={onChangeView}
          setAddProducts={setAddProducts}
        />
        <Col xs={24} sm={24} md={24} lg={24}>
          {addProducts ? (
            <ProjectProductList
              getProductsList={getProductsList}
              productsList={productsList}
              projectData={props.projectData}
              setProductsList={setProductsList}
              edit={edit}
              store={props.store}
              turn={props.turn}
              isSellCancelled={sellCancelled}
              uncancellSell={_ => setSellCancelled(false)}
              itemsWithoutStock={itemsWithoutStock}
            />
          ) : (
            <PosPaymentProject
              total={total}
              sellUnsaved={_ => setSaveSell(false)}
              saveSell={saveSell}
              productsList={productsList}
              closeProject={closeProject}
              store={props.store}
              turn={props.turn}
              projectData={props.projectData}
              symbol={symbol}
            />
          )}
        </Col>
        <Col xs={24} sm={24} md={24} lg={24} className={'footer-sell'}>
          <Row gutter={16} justify="space-between" align="middle">
            <Divider className={'divider-custom-margins-users'} />
            <Col xs={4} sm={4} md={4} lg={4}>
              <Button type={'link'} className="cancel-button" onClick={cancelSell}>
                Cancelar proyecto
              </Button>
            </Col>
            <Col xs={20} sm={20} md={20} lg={20}>
              {addProducts ? (
                <>
                  <div className="next-button">
                    <div>
                      TOTAL <span>{symbol} {trunc(total)}</span>
                    </div>
                    <Button htmlType="submit" className="title-tendero new-button" onClick={() => onChangeView(false)}>
                      Siguiente
                    </Button>
                  </div>
                </>
              ) : (
                <>
                  <div className="next-button">
                    <Button htmlType="submit" className="title-tendero new-button back-button" onClick={() => onChangeView(true)}>
                      &#60; Regresar
                    </Button>
                    <Button loading={loading} htmlType="submit" className="title-tendero new-button" onClick={finishProject}>
                      Finalizar
                    </Button>
                  </div>
                </>
              )}
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  )
}

export default ProjectIndex
